/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import TransactionsColumns from './TransactionsColumns';
import TransactionsRows from './TransactionsRows';

type TransactionsTableProps = {
  sort: string,
  order: string,
  children: any,
  router: Object
}

export default function TransactionsTable({
  children, sort, order, router
}: TransactionsTableProps): React.Element {
  return (
    <Table customDataTestID="table-transactions">
      <TransactionsColumns sort={sort} order={order}/>
      <TransactionsRows router={router}>
        {children}
      </TransactionsRows>
    </Table>
  );
}
